import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["action"]
const _hoisted_2 = {
  key: 0,
  class: "autobooking-form__info autobooking-form__info--reserved"
}
const _hoisted_3 = ["value"]
const _hoisted_4 = {
  key: 1,
  class: "autobooking-form__info"
}
const _hoisted_5 = ["value"]
const _hoisted_6 = ["value"]
const _hoisted_7 = ["value"]
const _hoisted_8 = ["value"]
const _hoisted_9 = ["value"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("u", null, "Dodatkowe dane auta", -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["value"]
const _hoisted_13 = ["value"]
const _hoisted_14 = ["value"]
const _hoisted_15 = ["value"]
const _hoisted_16 = ["value"]
const _hoisted_17 = ["value"]
const _hoisted_18 = {
  key: 1,
  class: "d-flex justify-content-center"
}

export function render(_ctx: any,_cache: any) {
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_DmDatalist = _resolveComponent("DmDatalist")!
  const _component_DmTextarea = _resolveComponent("DmTextarea")!
  const _component_DmSelect = _resolveComponent("DmSelect")!
  const _component_DmButton = _resolveComponent("DmButton")!
  const _component_AutobookingFormSkeleton = _resolveComponent("AutobookingFormSkeleton")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!!_ctx.calendarArray.length)
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          id: "autobookingFormSidebar",
          class: "autobooking-form",
          method: 'get',
          action: _ctx.redirect
        }, [
          (_ctx.initialSlotReserved)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_2, " Termin wybrany w poprzednim kroku został zajęty, wybierz nowy spośród dostępnych. "))
            : _createCommentVNode("", true),
          _createVNode(_component_Calendar, {
            ref: "calendar",
            "clicked-slots": _ctx.slotsSelected,
            days: _ctx.calendarArray,
            "web-columns": _ctx.dataWebColumns,
            class: "mb-15",
            onOnSlotsChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onSlotChange($event)))
          }, null, 8, ["clicked-slots", "days", "web-columns"]),
          _createElementVNode("input", {
            name: "data[AutobookingEvent][slot]",
            value: _ctx.slotSelected,
            type: "hidden"
          }, null, 8, _hoisted_3),
          (_ctx.showDeliveryDateInfo)
            ? (_openBlock(), _createElementBlock("h5", _hoisted_4, " Wybrany termin jest godziną podstawienia auta do warsztatu "))
            : _createCommentVNode("", true),
          _createElementVNode("input", {
            name: "data[AutobookingEvent][quantityWorkspace]",
            value: _ctx.showDeliveryDateInfo,
            type: "hidden"
          }, null, 8, _hoisted_5),
          _createVNode(_component_DmDatalist, {
            id: "autobooking-brand-select",
            modelValue: _ctx.brand,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.brand) = $event)),
            name: "data[AutobookingEvent][brand]",
            placeholder: "Marka",
            items: _ctx.brands,
            native: ""
          }, null, 8, ["modelValue", "items"]),
          _createElementVNode("input", {
            name: "data[AutobookingEvent][brandId]",
            value: _ctx.brand?.key,
            type: "hidden"
          }, null, 8, _hoisted_6),
          _createVNode(_component_DmDatalist, {
            id: "autobooking-model-select",
            modelValue: _ctx.model,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model) = $event)),
            class: "mt-10",
            name: "data[AutobookingEvent][model]",
            placeholder: "Model",
            items: _ctx.models,
            native: ""
          }, null, 8, ["modelValue", "items"]),
          _createElementVNode("input", {
            name: "data[AutobookingEvent][modelId]",
            value: _ctx.model?.key,
            type: "hidden"
          }, null, 8, _hoisted_7),
          (_ctx.repairReasonId === '2fb8fb93-ef7c-47a4-998d-2b4a8fa29f66')
            ? (_openBlock(), _createBlock(_component_DmTextarea, {
                key: 2,
                label: "Opisz swój problem (minimum 10 znaków)",
                id: "autobooking-repair-description-textarea",
                modelValue: _ctx.repairDescription,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.repairDescription) = $event)),
                name: "data[AutobookingEvent][repairDescription]",
                class: "mt-10",
                "min-height": 62,
                placeholder: "np. Podczas jazdy stuka mi coś w zawieszeniu"
              }, null, 8, ["modelValue"]))
            : (_openBlock(), _createBlock(_component_DmSelect, {
                key: 3,
                id: "autobooking-service-select",
                modelValue: _ctx.service,
                "onUpdate:modelValue": [
                  _cache[4] || (_cache[4] = ($event: any) => ((_ctx.service) = $event)),
                  _ctx.onUpdateSelect
                ],
                class: "mt-10",
                placeholder: "Usługa",
                items: _ctx.services,
                native: ""
              }, null, 8, ["modelValue", "onUpdate:modelValue", "items"])),
          _createElementVNode("input", {
            name: "data[AutobookingEvent][service]",
            value: _ctx.service?.key !== 'disabled' ? _ctx.service?.text : '',
            type: "hidden"
          }, null, 8, _hoisted_8),
          _createElementVNode("input", {
            name: "data[AutobookingEvent][serviceId]",
            value: _ctx.service?.key !== 'disabled' ? _ctx.service?.key : '9f1331f2-66c0-4341-ad06-cc6f074e1857',
            type: "hidden"
          }, null, 8, _hoisted_9),
          (!_ctx.showTextarea)
            ? (_openBlock(), _createElementBlock("a", {
                key: 4,
                class: "autobooking-form__add-note",
                role: "button",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showTextarea = true))
              }, _hoisted_11))
            : _createCommentVNode("", true),
          (_ctx.showTextarea)
            ? (_openBlock(), _createBlock(_component_DmTextarea, {
                key: 5,
                id: "autobooking-note-textarea",
                modelValue: _ctx.notes,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.notes) = $event)),
                name: "data[AutobookingEvent][notes]",
                class: "mt-10",
                "min-height": 62,
                placeholder: 'Typ silnika np. 2.7CDI 177KM olej napędowy'
              }, null, 8, ["modelValue", "placeholder"]))
            : _createCommentVNode("", true),
          _createElementVNode("input", {
            name: "data[AutobookingEvent][lng]",
            value: _ctx.mechanicMeta?.lng,
            type: "hidden"
          }, null, 8, _hoisted_12),
          _createElementVNode("input", {
            name: "data[AutobookingEvent][lat]",
            value: _ctx.mechanicMeta?.lat,
            type: "hidden"
          }, null, 8, _hoisted_13),
          _createElementVNode("input", {
            name: "data[AutobookingEvent][address]",
            value: _ctx.mechanicMeta?.address,
            type: "hidden"
          }, null, 8, _hoisted_14),
          _createElementVNode("input", {
            name: "data[AutobookingEvent][zilo_id]",
            value: _ctx.mechanicMeta?.zilo_id,
            type: "hidden"
          }, null, 8, _hoisted_15),
          _createElementVNode("input", {
            name: "data[AutobookingEvent][mechanic_id]",
            value: _ctx.dataMechanicId,
            type: "hidden"
          }, null, 8, _hoisted_16),
          _createElementVNode("input", {
            name: "data[AutobookingEvent][category_id]",
            value: _ctx.repairReasonId,
            type: "hidden"
          }, null, 8, _hoisted_17),
          _createVNode(_component_DmButton, {
            class: "mt-15 width-100",
            disabled: _ctx.formInvalid,
            title: "Następny krok"
          }, null, 8, ["disabled"])
        ], 8, _hoisted_1))
      : (!!_ctx.slots)
        ? (_openBlock(), _createElementBlock("h4", _hoisted_18, " Brak wolnych terminów "))
        : (_openBlock(), _createBlock(_component_AutobookingFormSkeleton, { key: 2 }))
  ]))
}